var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordIconNewUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M203.6,95.9C202.9,48.4,169.3,10,128,10S53.1,48.4,52.4,95.9c-7.1,4-11.9,11.6-11.9,20.2v106.6c0,12.8,10.5,23.2,23.2,23.2h128.5c12.8,0,23.2-10.5,23.2-23.2V116.2C215.5,107.5,210.7,99.9,203.6,95.9z M138,177.5v33.8c0,5.5-4.5,10-10,10c-5.5,0-10-4.5-10-10v-33.8c-10.1-4-17.3-13.8-17.3-25.4c0-15.1,12.2-27.3,27.3-27.3c15.1,0,27.3,12.3,27.3,27.3C155.4,163.7,148.2,173.5,138,177.5z M68.9,92.9c2-37.1,27.7-66.5,59.1-66.5c31.4,0,57.1,29.5,59.1,66.5H68.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIconNewUser);
export default __webpack_public_path__ + "static/media/passwordIconNewUser.857b0120184c4a2762a63fdcf2ca45d8.svg";
export { ForwardRef as ReactComponent };